import { render } from "./Index.vue?vue&type=template&id=ae729a92"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render

export default script